// 案件模块翻译汇总
import caselist from "./caselist.js";
import newcaselist from "./newcaselist.js";
import addcase from "./addcase.js";
import canvaslist from "./canvaslist.js";
import caseDescribe from "./caseDescribe.js";
import addcanvas from "./addcanvas.js";
import editcanvas from "./editcanvas.js";
import canvasAnalysisTab from "./canvasAnalysisTab.js";
import editcase from "./editcase.js";
import dataBulletinBoard from "./dataBulletinBoard.js";
import addressMonitor from "./addressMonitor.js";
import keyaddressInfo from "./keyaddressInfo.js";
import characterInfo from "./characterInfo.js";
import caseHeader from "./caseHeader.js";
import assetChart from "./assetChart.js";

export default {
  caselist,
  newcaselist,
  addcase,
  canvaslist,
  caseDescribe,
  addcanvas,
  editcanvas,
  canvasAnalysisTab,
  editcase,
  dataBulletinBoard,
  addressMonitor,
  keyaddressInfo,
  characterInfo,
  caseHeader,
  assetChart,
};
